// src/pages/HelpChatLanguageSelector.jsx
import React from 'react';

import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { fr, it, enUS, de, pt, es, ru } from 'date-fns/locale'; // pour trduire le calendrier


const flagsByRegion = {
  "🇪🇺 Europe": {
    fr: "🇫🇷", it: "🇮🇹", de: "🇩🇪", es: "🇪🇸", pt: "🇵🇹",
    nl: "🇳🇱", no: "🇳🇴", sv: "🇸🇪", da: "🇩🇰", is: "🇮🇸",
    pl: "🇵🇱", fi: "🇫🇮", cs: "🇨🇿", el: "🇬🇷", hu: "🇭🇺",
    ro: "🇷🇴", sk: "🇸🇰", sl: "🇸🇮", bg: "🇧🇬"
  },
  "🌍 English": {
    en: "🇬🇧", us: "🇺🇸", au: "🇦🇺", ca: "🇨🇦"
  },
  "🌏 Asia": {
    zh: "🇨🇳", ja: "🇯🇵", ko: "🇰🇷", hi: "🇮🇳",
    th: "🇹🇭", vi: "🇻🇳", id: "🇮🇩"
  },
  "🌎 Others": {
    ru: "🇷🇺", tr: "🇹🇷", ar: "🇸🇦"
  }
};

const HelpChatLanguageSelector = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  

  return (
    <div style={{ height: '100vh', width: '100vw', textAlign: 'center', paddingTop: '20px' }}>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: '20px' }}>
        <a href="/" style={{ textDecoration: 'none', color: 'inherit', marginRight: '20px' }}>
          <img
            src="/images/logo.png"
            alt={t('header.logoAlt', { defaultValue: 'Villa Pina e Paolo logo' })}
            style={{ height: '150px', marginBottom: '0' }}
          />
        </a>
        <div style={{ padding: '10px', textAlign: 'center' }}>
          <h1 style={{ textAlign: 'center' }}>{t('header.title')}</h1>
          <p className='headerSub' style={{ textAlign: 'center' }}>{t('header.subtitle')}</p>
        </div>
      </div>
      <h2>🌍 Choose your language</h2>
      {Object.entries(flagsByRegion).map(([region, langs]) => (
        <div key={region} style={{ marginTop: 40 }}>
          <h3 style={{ marginBottom: 12 }}>{region}</h3>
          <div style={{ fontSize: '2.5rem', flexWrap: 'wrap' }}>
            {Object.entries(langs).map(([langCode, flag]) => (
              <span
                key={langCode}
                onClick={() => navigate(`/help/${langCode}`)}
                style={{ cursor: 'pointer', margin: '0 5px', opacity: 0.9 }}
                title={langCode}
              >
                {flag}
              </span>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
};

export default HelpChatLanguageSelector;
